import styled, { keyframes } from "styled-components"


const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
  
`;

export const Container = styled.div`
    opacity: 0;
    display: block;
    padding: 20px 10px;
    font-size: 30px;
    text-align: center;
    z-index: 5;
    top: 170px;
    right: 0;
    position: fixed;
    animation: ${fadeIn} 500ms forwards;
    animation-delay: 2s;
    box-sizing: border-box;

`;

export const MediaItem = styled.a`
    color: #e0e0e0;
    margin: 10px;
    cursor: pointer;
    display: block;
    
    &:hover{
            color: #BB86FC;
    }

`;
